import { InjectionToken, Type } from '@angular/core';

export const USER_DRAWER_WIDGET = new InjectionToken<any>('User Drawer Widget');

export interface Widget extends Type<unknown> {
  title: string;
  group: string;
}
